import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext";
import "./Footer.css";

const Footer = () => {
  const { logoUrl, loading, footerSettings: lpSettings } = useTheme();
  const socialLinks = [
    ["facebook_url", "Facebook", FaFacebook],
    ["twitter_url", "Twitter / X", FaTwitter],
    ["instagram_url", "Instagram", FaInstagram],
    ["youtube_url", "YouTube", FaYoutube],
  ].filter(([field]) => {
    try {
      const url = new URL(lpSettings?.[field]);
      return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password;
    } catch { return false; }
  });

  const namaLembaga = lpSettings?.nama_lembaga || "";
  const alamat =
    lpSettings?.alamat ||
    "Jl.Danau Singkarak No.32 LK.I, Kelurahan Surabaya Kecamatan Kedaton, Bandar Lampung Lampung 35148";
  const noHp = lpSettings?.no_hp || "+6282182226942";
  const email = lpSettings?.email || "edukasihalalindonesia@gmail.com";

  return (
    <footer className="footer bg-dark text-white mt-5">
      <Container>
        <Row className="py-5">
          <Col md={4} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={namaLembaga || "Logo Lembaga"}
                  style={{ width: "50px", height: "50px", marginRight: "15px" }}
                />
              ) : loading ? (
                <span
                  className="footer-logo-placeholder"
                  style={{ marginRight: "15px" }}
                  aria-hidden="true"
                />
              ) : null}
              <h5 className="mb-0">{namaLembaga}</h5>
            </div>
            <p className="text-light" style={{ whiteSpace: "pre-line", overflowWrap: "anywhere" }}>
              {lpSettings?.motto?.trim() || "Lembaga halal yang berkomitmen untuk menjaga kehalalan produk di Indonesia."}
            </p>
          </Col>

          <Col md={4} className="mb-4">
            <h5 className="mb-3">Kontak</h5>
            <div className="contact-info">
              <p>
                <FaMapMarkerAlt /> {alamat}
              </p>
              <p>
                <FaPhone /> {noHp}
              </p>
              <p>
                <FaEnvelope /> {email}
              </p>
            </div>
          </Col>

          {socialLinks.length > 0 && <Col md={4} className="mb-4">
            <h5 className="mb-3">Ikuti Kami</h5>
            <div className="social-icons">
              {socialLinks.map(([field, label, Icon]) => (
                <a key={field} href={lpSettings[field]} aria-label={label}
                  target="_blank" rel="noopener noreferrer">
                  <Icon size={30} />
                </a>
              ))}
            </div>
          </Col>}
        </Row>

        <Row>
          <Col className="text-center py-3 border-top border-secondary">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} {namaLembaga}. All rights
              reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
